import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  theme,
} from "antd";
import { Space } from "antd";
import { clearLocalStore } from "helpers/localStoreSrv";
import {
  InputText,
  InputDate,
  InputAutoComplete,
  InputTextArea,
  InputPhoto,
  FileUpload
} from "hlsreact";
import moment from 'moment';
import BrandColors from "@brand-colors";
import "./VisitIntake.css";
import { useVisitIntakeSrv } from './useVisitIntakeSrv';
import type { UploadFile } from 'antd';
import whitelabelConfig from "@whitelabel-config";
import ReactGA from 'react-ga';
import { useUiState } from "helpers/useUiState";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { t } from "i18next";
import { handleErrorNavigation } from 'pages/ErrorPage/ErrorHandler';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const { useToken } = theme;
const { useBreakpoint } = Grid;
const VisitIntake = () => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { isAppLoading } = useUiState();

  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage,"preferredLanguage")
  const [isRightAlign, setIsRightAlign] = useState(false);
  
  const [formData, setFormData] = useState({
    VisitDate: null,
    Reason: "",
    Procedure: "",
    ProviderName: "",
    file: "",
  });

  const handleInputChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const styles = {
    container: {
      margin: "0 auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      marginBottom: token.marginXL,
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      padding: screens.md ? `15px 25px` : "0px",
      textAlign: "left",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "100%",
      marginTop: "15px",
      fontWeight: "bold",
    },
    upload: {
      display: "flex",
      background: "#f00",
    },
    subheader: {
      fontWeight: "600",
      marginBottom: "8px",
      marginTop: "16px",
      display: "flex",
      width: "100%",
      justifyContent: isRightAlign ? "flex-end" : "flex-start",
    },
    error: {
      color: "#f00",
      marginTop: "10px",
      textAlign: isRightAlign ? "right" : "left",
    },
    visitListTable: {
      width: "100%",
      border: "1px solid #dee2e6",
      borderCollapse: "collapse",
    },
    visitTblTh: {
      textAlign: isRightAlign ? "right" : "left",
      background: "#e9ecef",
      padding: "10px",
      border: "1px solid #dee2e6",
      borderCollapse: "collapse",
    },
    visitTblTd: {
      padding: "8px 10px",
      border: "1px solid #dee2e6",
      borderCollapse: "collapse",
      textAlign: isRightAlign ? "right" : "left",
    },
  };

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  type ErrorState = {
    isError: boolean;
    errMsg: string;
  };

  const initialErrorState: ErrorState = {
    isError: false,
    errMsg: "",
  };

  const [isVisitDateError, setIsVisitDateError] = useState(initialErrorState);
  const [isReasonError, setIsReasonError] = useState(initialErrorState);
  const [isProcedureError, setIsProcedureError] = useState(initialErrorState);
  const [isProviderNameError, setIsProviderNameError] =
    useState(initialErrorState);
  const [isUploadError, setIsUploadError] = useState(initialErrorState);

  const validateAddress = (data: any) => {
    console.log("Test Vali         " + JSON.stringify(data));

    let isValid = true;
    if (!data.VisitDate) {
      setIsVisitDateError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.ENTER_VISIT_DATE"),
      });
      isValid = false;
    } else {
      setIsVisitDateError(initialErrorState);
    }

    if (!data.Reason) {
      setIsReasonError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.ENTER_REASON"),
      });
      isValid = false;
    } else {
      setIsReasonError(initialErrorState);
    }

    if (!data.Procedure) {
      setIsProcedureError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.ENTER_PROCEDURE"),
      });
      isValid = false;
    } else {
      setIsProcedureError(initialErrorState);
    }

    if (fileList.length === 0) {
      setIsUploadError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.UPLOAD_FILE"),
      });
      isValid = false;
    } else {
      setIsUploadError(initialErrorState);
    }

    if (!data.ProviderName) {
      setIsProviderNameError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.ENTER_PROVIDER_NAME"),
      });
      isValid = false;
    } else if (data.ProviderName && !(/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(data.ProviderName))) {
      setIsProviderNameError({
        isError: true,
        errMsg: t("VISITINTAKE_PAGE.ENTER_VALID_PROVIDER_NAME"),
      });
      isValid = false;
    }
    else {
      setIsProviderNameError(initialErrorState);
    }
    return isValid;
    isAppLoading(false);
  };

  const { submitVisitIntake, getProcedure, getVisitList } = useVisitIntakeSrv();
  const handleSubmit = () => {
    console.log("Test")
    console.log("fileList", fileList[0])
    const isValid: any = validateAddress(formData);
    console.log("isValid", isValid)
    if (isValid) {
      const mxFormData = new FormData();
      mxFormData.append("file", fileList[0] as any);
      mxFormData.append("VisitStartDate", formData.VisitDate);
      mxFormData.append("ActualStartDate", formData.VisitDate);
      mxFormData.append("VisitReason", formData.Reason);
      mxFormData.append("ProviderName", formData.ProviderName);
      mxFormData.append("Procedure", formData.Procedure);
      isAppLoading(true);
      submitVisitIntake(mxFormData)
        ?.then((res) => {
          isAppLoading(false);
          setFormData({
            VisitDate: "",
            Reason: "",
            Procedure: "",
            ProviderName: "",
          })
          setFormData({ VisitDate: null })
          setUploadHide(false)
          setCameraOn(false)
          setFileList([])
          getVistInformations()

        })
        .catch((e) => {
          console.log(e);
          isAppLoading(false);
          clearLocalStore();
          handleErrorNavigation(e, navigate, t);
        });
    }
  }

  const getVistInformations = () => {
    getVisitList()
      ?.then((res) => {
        (async () => {
          setVisitGridList(res.data);
        })();
      })
      .catch((e) => {
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      });
  };
  const [procedures, setprocedures] = useState([]);
  const [visitGridList, setVisitGridList] = useState([]);

  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [ whitelabelConfig, preferredLanguage]);

  useEffect(() => {
    getProcedure()
      ?.then((res) => {
        (async () => {
          setprocedures(res.data);
        })();
      })
      .catch((e) => {
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      });
  }, []);

  useEffect(() => {
    getVistInformations()
    ReactGA.event({
      category: 'Visit Intake Page loaded ',
      action: 'Visit Intake Page loaded',
      label: 'Visit Intake Page',
    });
  }, []);
  const proceduresValList = procedures;



  const [cameraOn, setCameraOn] = useState(false);
  const handleCamera = async () => {
    setCameraOn(!cameraOn);
  };
  const [uploadHide, setUploadHide] = useState(false);
  const handleOnCapture = (imageData: any) => {
    setFileList([imageData]);
    setUploadHide(true)
  }

  const handleFileChange = (file: any) => {
    if (file) {
      setFileList([file]);
      setFormData({
        ...formData,
        ['file']: true,
      });
      console.log("handleFileChange Have ", file)
    } else {
      setFileList([]);
      console.log("handleFileChange Null ", file)
    }

  };
  return (
    <section style={styles.section}>
      <div style={{ width: "100%", padding: "15px" }}>
        <div style={styles.header} data-testid="test-visitIntake-form">
          <lable style={styles.subheader}>{t("VISITINTAKE_PAGE.VISIT_DATE")}</lable>
          <InputDate shape={"round"} primaryColor={"#333"}
            value={formData.VisitDate}
            onChange={(e: any) =>
              handleInputChange("VisitDate", e)
            }
          />
          {isVisitDateError.isError === true ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={styles.error}>{isVisitDateError.errMsg}</div>
            </Space>
          ) : null}

          <lable style={styles.subheader}>{t("VISITINTAKE_PAGE.REASON")}</lable>
          <InputTextArea primaryColor={"#333"}
            shape={"round"}
            value={formData?.Reason}
            data-testid="test-visitintake-textarea"
            onChange={(e: any) => handleInputChange("Reason", e)}
          />
          {isReasonError.isError === true ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={styles.error}>{isReasonError.errMsg}</div>
            </Space>
          ) : null}

          <lable style={styles.subheader}>{t("VISITINTAKE_PAGE.PROCEDURE")}</lable>
          <InputAutoComplete primaryColor={"#333"}
            value={formData.Procedure}
            options={proceduresValList}
            onChange={(e: any) =>
              handleInputChange("Procedure", e)
            }
          />
          {isProcedureError.isError === true ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={styles.error}>{isProcedureError.errMsg}</div>
            </Space>
          ) : null}

          <lable style={styles.subheader}>{t("VISITINTAKE_PAGE.PROVIDER_NAME")}</lable>
          <InputText
            shape={"round"}
            value={formData.ProviderName}
            onChange={(e: any) =>
              handleInputChange("ProviderName", e)
            }
            primaryColor={"#333"}
          />
          {isProviderNameError.isError === true ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={styles.error}>{isProviderNameError.errMsg}</div>
            </Space>
          ) : null}

          <lable style={styles.subheader}>{t("VISITINTAKE_PAGE.ATTACHMENT")} {formData.file}</lable>
          {!uploadHide &&

            <FileUpload
              maxFileSize={1}
              allowedFormats={whitelabelConfig.uiSettings.allowedFormats}
              onChange={handleFileChange}
              defaultValue={formData.file}
              data-testid="test-visitintake-upload"
              primaryColor={"#333"}
            />
          }
          {isUploadError.isError === true ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={styles.error}>{isUploadError.errMsg}</div>
            </Space>
          ) : null}


          <Button
            data-testid="test-visit-camera"
            style={{ verticalAlign: "middle" }}
            type="primary"
            className="btn-fab1 btn-forward1"
            style={styles.button}
            onClick={handleCamera}
          >
            {!cameraOn ? t("VISITINTAKE_PAGE.CAMARA_ON") : t("VISITINTAKE_PAGE.CAMARA_OFF")}
          </Button>

          {cameraOn &&
            <InputPhoto
              data-testid="test-visit-inputphoto"
              height={500} width={600}
              outputType={"base64"}
              onCapture={handleOnCapture}
            />
          }
          <Button
            data-testid="test-visit-submit"
            style={{ verticalAlign: "middle" }}
            type="primary"
            className="btn-fab1 btn-forward1"
            style={styles.button}
            onClick={handleSubmit}
          >
            {t("VISITINTAKE_PAGE.SUBMIT")}
          </Button>

        </div>
        <div style={styles.header}>
          <h1 style={{ fontSize: screens.md ? "21px" : "18px",textAlign: isRightAlign ? "right" : "left" }}>{t("VISITINTAKE_PAGE.VISIT_LIST")}</h1>
          <div style={{ overflow: "auto" }}>
            <table style={styles.visitListTable}>
              <thead style={styles.visitTblHeader}>
                <tr>
                  <th style={styles.visitTblTh}>{t("VISITINTAKE_PAGE.PROVIDER_NAME")}</th>
                  <th style={styles.visitTblTh}>{t("VISITINTAKE_PAGE.DATE")}</th>
                  <th style={styles.visitTblTh}>{t("VISITINTAKE_PAGE.PROCEDURE")}</th>
                  <th style={styles.visitTblTh}>{t("VISITINTAKE_PAGE.REASON")}</th>
                </tr>
              </thead>
              <tbody>
                {visitGridList.map((res: any) =>
                  <tr>
                    <td style={styles.visitTblTd}>{res.ProviderName}</td>
                    <td style={styles.visitTblTd}>{moment(res.VisitStartDate).format('MMM DD, YYYY hh:mm A')}</td>
                    <td style={styles.visitTblTd}>{res.Procedure}</td>
                    <td style={styles.visitTblTd}>{res.VisitReason}</td>
                  </tr>
                )
                }
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </section>
  )
}
export default VisitIntake;